/*
INTELLECTUAL PROPERTY NOTICE
© Kaleida Ltd. All rights reserved.
This file contains Protected Intellectual Property owned by Kaleida Ltd and forms part of an application developed by Kaleida within the Platform.
Protected Intellectual Property may only be used as incorporated within applications developed by Kaleida within the Platform and must not be used, reproduced, adapted, or incorporated into any application developed by or on behalf of the Customer (explicitly not developed by Kaleida), whether or not such application forms part of the Platform.
For the avoidance of doubt, the inclusion of any application within the Platform does not of itself grant any right to use Protected Intellectual Property in that application unless that application was developed by Kaleida.
*/

// IP-NOTICE: PROTECTED
import { Injectable } from '@angular/core';
import { DataService } from './data.service';
import { ApiDependenciesService } from 'app/api/services/api-dependencies.service';
import { interval, Subscription } from 'rxjs';

@Injectable({providedIn: 'root'})
export class KeepAliveService extends DataService<any> {
  readonly checkVersionInterval = 30000;
  isRunning: boolean;

  private subscription: Subscription;

  constructor(protected dependencies: ApiDependenciesService) {
    super(dependencies);
    this.startHeartbeat();
  }

  startHeartbeat() {
      return;
    if (this.isRunning) {
      return;
    }
    this.subscription = interval(this.checkVersionInterval).subscribe(val => {
      console.debug('heartbeat called');
      this.callHeartbeat();
    });

    this.isRunning = false;
  }

  async callHeartbeat(): Promise<boolean> {
    let model: boolean;
    await this.setEndpoint('/application/heartbeat')
      .getSingle()
      .then(response => {
        model = response;
      });
    return Promise.resolve(model);
  }

  async checkAuthentication(): Promise<boolean> {
    let model: boolean;
    await this.setEndpoint('/application/check-authentication')
      .getSingle()
      .then(response => {
        model = response;
      });
    return Promise.resolve(model);
  }

}
